import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PlaneHistory = ({parameter, history}) => { 
    let h = history.slice(Math.max(0, history.length - 10)).map(
        h => h[parameter.id]);
    let first = h[0];
    if (!first) {
        return [];
    }
    let d = "M " + first.x + "," + first.y + " C" +
        h.slice(1).map(({x,y}) => x+','+y).join(',');
    return (<path
              className="history-path"
              d={d}
              stroke="white"
              strokeWidth={2}
            />);
    
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneHistory);
